import { c as _c } from "react/compiler-runtime";
import Button from "@/Components/Common/Buttons/Buttons";
import React from "react";
const CancelRequestedMeeting = t0 => {
  const $ = _c(27);
  const {
    onClose,
    cancelSelectedAppointment,
    isLoading
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <h2 className="text-base font-semibold font-poppins text-gray-900">Cancel Request</h2>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== onClose) {
    t3 = <div className="flex sm:hidden items-center justify-between w-full px-4 py-3 border-b border-gray-100 flex-shrink-0">{t1}<button onClick={onClose} className="p-1.5 rounded-lg hover:bg-gray-100">{t2}</button></div>;
    $[2] = onClose;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="w-14 h-14 sm:w-16 sm:h-16 p-3 sm:p-4 bg-red-500 rounded-full justify-center items-center inline-flex"><div className="w-7 h-7 sm:w-8 sm:h-8 relative flex-col justify-start items-start flex"><svg xmlns="http://www.w3.org/2000/svg" width="33" height="32" viewBox="0 0 33 32" fill="none"><path d="M4.38782 9.375L6.04838 29.4209C6.16738 30.8666 7.39876 32 8.84988 32H24.1502C25.6013 32 26.8327 30.8666 26.9517 29.4209L28.6122 9.375H4.38782ZM11.8116 28.25C11.3209 28.25 10.908 27.8682 10.8769 27.3711L9.93938 12.2461C9.90732 11.7288 10.3001 11.2839 10.8164 11.2518C11.352 11.2143 11.7778 11.6116 11.8107 12.1289L12.7482 27.2539C12.7814 27.7895 12.3576 28.25 11.8116 28.25ZM17.4375 27.3125C17.4375 27.8307 17.0182 28.25 16.5 28.25C15.9818 28.25 15.5625 27.8307 15.5625 27.3125V12.1875C15.5625 11.6693 15.9818 11.25 16.5 11.25C17.0182 11.25 17.4375 11.6693 17.4375 12.1875V27.3125ZM23.0606 12.2461L22.1231 27.3711C22.0923 27.8632 21.6821 28.2734 21.1289 28.2482C20.6125 28.2161 20.2198 27.7712 20.2518 27.2539L21.1893 12.1289C21.2214 11.6117 21.6746 11.2354 22.1836 11.2519C22.6999 11.2839 23.0927 11.7289 23.0606 12.2461Z" fill="white" /><path d="M28.6875 3.75H23.0625V2.8125C23.0625 1.26163 21.8009 0 20.25 0H12.75C11.1991 0 9.9375 1.26163 9.9375 2.8125V3.75H4.3125C3.27694 3.75 2.4375 4.58944 2.4375 5.625C2.4375 6.66044 3.27694 7.5 4.3125 7.5C12.9354 7.5 20.0649 7.5 28.6875 7.5C29.7231 7.5 30.5625 6.66044 30.5625 5.625C30.5625 4.58944 29.7231 3.75 28.6875 3.75ZM21.1875 3.75H11.8125V2.8125C11.8125 2.29525 12.2327 1.875 12.75 1.875H20.25C20.7673 1.875 21.1875 2.29525 21.1875 2.8125V3.75Z" fill="white" /></svg></div></div>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="flex-1 sm:flex-none flex flex-col justify-center items-center gap-4 sm:gap-6 w-full p-6 sm:p-8 sm:pb-0">{t4}<div className="flex-col justify-start items-center gap-4 sm:gap-6 flex w-full"><div className="flex-col justify-start items-center gap-2 flex px-2"><div className="text-center text-black text-2xl sm:text-[32px] font-semibold font-poppins">Are you sure?</div><div className="text-center text-neutral-400 text-sm sm:text-base font-normal font-poppins">Once you cancel this meeting request, you won't be able to schedule meeting from here.</div></div></div></div>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== onClose) {
    t6 = <button type="button" onClick={onClose} className="flex-1 border-2 border-gray-300 text-gray-700 text-sm font-semibold font-poppins rounded-lg py-2.5 hover:bg-gray-50 transition-colors">No</button>;
    $[6] = onClose;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const t7 = isLoading ? "Loading..." : "Yes";
  let t8;
  if ($[8] !== cancelSelectedAppointment || $[9] !== t7) {
    t8 = <button type="button" onClick={cancelSelectedAppointment} className="flex-1 text-white rounded-lg text-sm font-semibold font-poppins py-2.5 transition-all bg-[#2e45df] hover:bg-[#2539c0]">{t7}</button>;
    $[8] = cancelSelectedAppointment;
    $[9] = t7;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== t6 || $[12] !== t8) {
    t9 = <div className="w-full sm:hidden px-4 py-3 border-t border-gray-200 flex gap-2 flex-shrink-0 mt-auto bg-white">{t6}{t8}</div>;
    $[11] = t6;
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <div className="border-t border-zinc-100 pt-6" />;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== onClose) {
    t11 = <div className="flex-1 font-poppins"><Button border="1px solid #D53033" textColor="#D53033" width="100%" borderRadius="10px" onClick={onClose} padding="12px 16px">No</Button></div>;
    $[15] = onClose;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  const t12 = isLoading ? "Loading..." : "Yes";
  let t13;
  if ($[17] !== cancelSelectedAppointment || $[18] !== t12) {
    t13 = <div className="flex-1 font-poppins"><Button backgroundColor="#354EF0" border="1px solid #354EF0" textColor="white" width="100%" onClick={cancelSelectedAppointment} borderRadius="10px" padding="12px 16px">{t12}</Button></div>;
    $[17] = cancelSelectedAppointment;
    $[18] = t12;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  let t14;
  if ($[20] !== t11 || $[21] !== t13) {
    t14 = <div className="hidden sm:block w-full px-8 pb-8 pt-6">{t10}<div className="w-full flex gap-6">{t11}{t13}</div></div>;
    $[20] = t11;
    $[21] = t13;
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  let t15;
  if ($[23] !== t14 || $[24] !== t3 || $[25] !== t9) {
    t15 = <><div className="fixed inset-0 search-popup-bg z-40 flex justify-center items-end sm:items-center"><div className="w-full h-full sm:h-auto sm:w-[415px] bg-white rounded-none sm:rounded-2xl shadow border border-neutral-200 flex flex-col justify-between sm:justify-start items-center">{t3}{t5}{t9}{t14}</div></div></>;
    $[23] = t14;
    $[24] = t3;
    $[25] = t9;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  return t15;
};
export default CancelRequestedMeeting;